import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import CategoryCard from "./categories/categoryCard";
import { useResponsiveScreen } from "../../hooks/useResponsiveScreen";
// Styles
import "../../assets/saas/molecules/_categories.scss";
const CarCategories = ({ currency, categories, rate, renters, totalDays, setData, extraFilters, filters, setFilters, showFilters, noResultstate, setLoading, shouldBeSelectedfilters, categoryTranslations, setSortBy, setSortOrder, sortOrder, isSearchCompleted, isFinal, 
// WI #8534 — threaded down to RenderCategoryItems to gate the
// Empty-definitive state (collapse only when `isFinal && isComplete`).
isComplete, 
// WI #8534 — passed to CategoryCard so handleSelect can synchronously
// arm the click-cut barrier in the parent before `setFilters` fires.
onFilterClick, collections = [], }) => {
    const stickyBarRef = useRef(null);
    const [isMinimal, setIsMinimal] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [appParamPresent, setAppParamPresent] = useState(false);
    // AB#8323 — canonical mobile threshold (992px) via shared hook,
    // replacing the inconsistent `window.innerWidth < 996` magic number.
    const { isMobile } = useResponsiveScreen();
    //get the url params, if app param is present, set the state to true
    useEffect(() => {
        if (queryParams.get('app') != null) {
            setAppParamPresent(true);
        }
    }, []);
    /**
     * Function to move the element on scroll in only mobile
     */
    useEffect(() => {
        let lastScrollTop = 0;
        let scrollThreshold = 5; // Threshold to avoid small fluctuations
        let lastScrollTime = 0;
        let scrollVelocity = 0;
        // Function to move the element on scroll with scroll speed calculation
        function moveElementOnScrollVersionTime(event) {
            var _a;
            if (!isMobile)
                return;
            const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
            const sticky = document.querySelector('.sticky-bar-flotante');
            const availability = document.querySelector('.collection-list');
            if (!availability || !sticky)
                return;
            const { top: topAvailability } = availability.getBoundingClientRect();
            const { top: topSticky, height } = sticky.getBoundingClientRect();
            // Calculate scroll velocity
            const now = Date.now();
            const dt = (now - lastScrollTime) || 16.67; // Set a default value in case there is no time difference
            const scrollDelta = currentScrollTop - lastScrollTop;
            scrollVelocity = (scrollDelta / dt) * 1000; // Velocity in pixels per second
            const velocityFactor = Math.min(Math.abs(scrollVelocity) / 2000, 1); // Velocity factor, limited between 0 and 1
            let directionScroll = '';
            // Only update the direction if the difference between current and previous position is greater than the threshold
            if (Math.abs(currentScrollTop - lastScrollTop) >= scrollThreshold) {
                directionScroll = currentScrollTop > lastScrollTop ? 'down' : 'up';
                lastScrollTop = currentScrollTop; // Update the previous scroll value
            }
            // Logic to make the element "sticky" if necessary
            if (topAvailability - height < 0) {
                sticky.classList.remove('d-none');
            }
            else if (topAvailability - height >= 0) {
                sticky.classList.add('d-none');
                sticky.style.transform = `translateY(-80px)`;
            }
            if (sticky.classList.contains('d-none'))
                return;
            // Here we calculate how to move the sticky element based on scroll velocity
            const transform = sticky.style.transform === '' ? 'translateY(0px)' : sticky.style.transform;
            let transformValue = (_a = parseInt(transform.replace(/^translateY\(([-\d.]+)px\)$/, '$1'))) !== null && _a !== void 0 ? _a : 0;
            // Adjust the position of the sticky element based on scroll direction and speed
            if (directionScroll === 'up' && transformValue < 0) {
                transformValue = transformValue + velocityFactor * 10; // Move up, multiplied by the velocity factor
                transformValue = transformValue < 0 ? transformValue : 0;
                sticky.style.transform = `translateY(${Math.round(transformValue * 1000) / 1000}px)`;
            }
            else if (directionScroll === 'down' && transformValue > -80) {
                transformValue = transformValue - velocityFactor * 10; // Move down, multiplied by the velocity factor
                transformValue = transformValue < 0 ? transformValue : 0;
                sticky.style.transform = `translateY(${Math.round(transformValue * 1000) / 1000}px)`;
            }
            // Update the last scroll time
            lastScrollTime = now;
        }
        // Add the scroll event listener
        window.addEventListener('scroll', moveElementOnScrollVersionTime);
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', moveElementOnScrollVersionTime);
        };
    }, [isMobile]);
    /**
     * Function to move the element on scroll in only desktop
     */
    useEffect(() => {
        const handleScroll = () => {
            if (isMobile)
                return;
            if (stickyBarRef.current) {
                const stickyBarHeight = stickyBarRef.current.offsetHeight;
                const scrollPosition = window.scrollY;
                const windowWidth = window.innerWidth;
                if (windowWidth > 996) {
                    if (scrollPosition > stickyBarHeight) {
                        setIsMinimal(true);
                    }
                    else {
                        setIsMinimal(false);
                    }
                }
                else {
                    if (scrollPosition > prevScrollPos && scrollPosition > 0) {
                        setIsMinimal(true);
                    }
                    else {
                        setIsMinimal(false);
                    }
                    setPrevScrollPos(scrollPosition);
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [prevScrollPos, isMobile]);
    return _jsx(_Fragment, { children: _jsx("div", { ref: stickyBarRef, className: `sticky-bar ${isMinimal ? 'sticky-bar--down' : ''} ${!showFilters ? 'sticky-bar--hidden' : ''}`, style: appParamPresent ? { display: !showFilters || noResultstate ? "none" : "block", marginTop: "0" } : { display: !showFilters || noResultstate ? "none" : "block" }, children: _jsx("div", { className: `categories`, id: "categoryContainer", children: _jsx(CategoryCard, { currency: currency, categories: categories, rate: rate, renters: renters, setData: setData, totalDays: totalDays, extraFilters: extraFilters, filters: filters, setFilters: setFilters, noResultstate: noResultstate, setLoading: setLoading, shouldBeSelectedfilters: shouldBeSelectedfilters, categoryTranslations: categoryTranslations, setSortBy: setSortBy, setSortOrder: setSortOrder, sortOrder: sortOrder, showFilters: showFilters, isSearchCompleted: isSearchCompleted, isFinal: isFinal, isComplete: isComplete, onFilterClick: onFilterClick, collections: collections }) }) }) });
};
export default CarCategories;
